import React from 'react';
import {FormMessage} from '@stubhub/bamboo';

export function RenderErrorMessage(props) {
  const {intl, errorMessage} = props;
  const formattedErrorMessage =
    errorMessage.id != null && errorMessage.defaultMessage != null
      ? intl.formatMessage(errorMessage)
      : errorMessage;

  return (
    <FormMessage className="InputField__container--error" status="error">
      {formattedErrorMessage}
    </FormMessage>
  );
}
